var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"outlined":_vm.outlined,"block":_vm.block,"disabled":_vm.disabled,"color":"primary","small":_vm.$vuetify.breakpoint.smAndDown},on:{"click":_vm.click}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }